import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import Reveal from "@/components/Reveal";

export const Concept = () => {
  const { t } = useLang();
  return (
    <section id="concept" data-testid="concept-section" className="section-pad bg-[var(--ms-soft-white)] text-[var(--ms-ink)]">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-12 gap-10 lg:gap-20 items-center">
        <Reveal className="lg:col-span-6">
          <span className="ornament">{t.concept.overline}</span>
          <h2 data-testid="concept-title" className="mt-6 font-serif text-[var(--ms-blue-dark)] text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight whitespace-pre-line">{t.concept.title}</h2>
          <p className="mt-8 text-base md:text-lg leading-relaxed">{t.concept.paragraph1}</p>
          <p className="mt-5 text-base md:text-lg leading-relaxed">{t.concept.paragraph2}</p>
        </Reveal>
        <Reveal delay={180} className="min-w-0 lg:col-span-6 lg:pl-8">
          <div className="flex items-start gap-4 overflow-x-auto snap-x snap-mandatory pb-3 md:grid md:grid-cols-12 md:gap-5 md:overflow-visible md:pb-0">
            <img src="/Interior 2.png" alt={t.concept.imageAlt} loading="lazy" decoding="async" className="block w-[88%] h-auto shrink-0 snap-start border border-black/10 shadow-sm md:col-span-7 md:w-full" />
            <img src="/Exterior 2.png" alt="Monte Sol Vilamoura — exterior" loading="lazy" decoding="async" className="block w-[88%] h-auto shrink-0 snap-start border border-black/10 shadow-sm md:col-span-5 md:mt-16 md:w-full" />
          </div>
          <div className="relative mt-6 lg:-ml-12 bg-[var(--ms-ivory)] border-l-2 border-[var(--ms-gold)] p-6 md:p-8 lg:mr-10">
            <blockquote className="font-serif italic text-[var(--ms-blue-dark)] text-2xl md:text-3xl leading-tight">&ldquo;{t.concept.quote}&rdquo;</blockquote>
            <p className="mt-5 text-sm leading-relaxed">{t.concept.signatureNote}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
